<template>
  <TabsBtn
    :tabs="tabs"
    :activeTab="activeTab"
    @change="changeTab"
    :isShowBorder="true"
  />
  <div
    v-if="matches.length"
    class="as-h2h as-scrolling as-scrolling__result-popup"
  >
    <div class="as-match-list as-mt-12" :key="activeTab">
      <MatchItem
        v-for="(item, key) in matches"
        :key="key"
        :match="item"
        :teams="matchLiveData.teams"
        :competitions="matchLiveData.competitions"
        :commentators="matchLiveData.commentators"
        :isShowFlagHalf="false"
        :mode="mode"
      />
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed, getCurrentInstance } from "vue";
import type { IMatch, IMatchLiveData } from "~src/interfaces/tennis";
import MatchItem from "~src/components/matches/tennis/MatchItem.vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
// import * as MatchEnumVolleyball from "~src/enums/volleyball/MatchEnum";
import MatchEnumVolleyball from "~src/enums/volleyball/MatchEnum";

interface IProps {
  matchLiveData: IMatchLiveData;
  matchId: string;
  mode?: string;
}

const props = withDefaults(defineProps<IProps>(), {});
const instance: any = getCurrentInstance();
const activeTab = ref("all");

const tabs = computed(() => {
  let _tabs = [
    {
      title: "Tất cả trận",
      key: "all",
    },
    {
      title: "SET 1",
      key: "h1",
    },
    {
      title: "SET 2",
      key: "h2",
    },
    {
      title: "SET 3",
      key: "h3",
    },
  ];

  if (instance?.proxy?.gSportType !== "badminton") {
    _tabs = [
      ..._tabs,
      {
        title: "SET 4",
        key: "h4",
      },
      {
        title: "SET 5",
        key: "h5",
      },
    ];
  }

  return _tabs;
});

const matches = computed(() => {
  // define set status
  let _FIRST_SET = MatchEnum.STATUS_FIRST_SET;
  let _SECOND_SET = MatchEnum.STATUS_SECOND_SET;
  let _THIRD_SET = MatchEnum.STATUS_THIRD_SET;
  let _FOURTH_SET = MatchEnum.STATUS_FOURTH_SET;
  let _FIFTH_SET = MatchEnum.STATUS_FIFTH_SET;
  let _END = MatchEnum.STATUS_END;
  let _LIST_STATUS_PLAYING = MatchEnum.LIST_STATUS_PLAYING;

  if(instance?.proxy?.gSportType === "volleyball"){
    _FIRST_SET = MatchEnumVolleyball.FIRST_SET;
    _SECOND_SET = MatchEnumVolleyball.SECOND_SET;
    _THIRD_SET = MatchEnumVolleyball.THIRD_SET;
    _FOURTH_SET = MatchEnumVolleyball.FOURTH_SET;
    _FIFTH_SET = MatchEnumVolleyball.FIFTH_SET;
    _END = MatchEnumVolleyball.ENDED;
    _LIST_STATUS_PLAYING = MatchEnumVolleyball.LIST_STATUS_PLAYING;
  }

  return props.matchLiveData.matches.filter((match: IMatch) => {
    const ft = match?.scores?.ft ?? [];
    if (
      match.id === props.matchId ||
      match.status_id === _END
    ) {
      return false;
    }

    if (activeTab.value === "all") {
      return true;
    }

    if (!_LIST_STATUS_PLAYING.includes(match.status_id)) {
      return false;
    }

    if (activeTab.value === "goal") {
      if (ft && (ft[0] != 0 || ft[1] != 0)) {
        return true;
      }

      return false;
    } else if (activeTab.value === "no_goal") {
      if (ft && ft[0] === 0 && ft[1] === 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h1") {
      if (match.status_id === _FIRST_SET) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h2") {
      if (match.status_id === _SECOND_SET) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h3") {
      if (match.status_id === _THIRD_SET) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h4") {
      if (match.status_id === _FOURTH_SET) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h5") {
      if (match.status_id === _FIFTH_SET) {
        return true;
      }

      return false;
    }

    return true;
  });
});

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const changeTab = async (tab: string) => {
  activeTab.value = tab;
};
</script>

<script lang="ts">
export default {};
</script>
